export default __webpack_public_path__ + "static/media/icon-seventh-fire.7896e963.svg";